export * from "-!../../../../../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./game-betconstruct.vue?vue&type=template&id=6140085b"


//////////////////
// WEBPACK FOOTER
// ./skins/bulmasite/components/pages/sitepages/game/game-betconstruct.vue?vue&type=template&id=6140085b
// module id = EguD
// module chunks = 0